import React from "react";
import "../../Styles/certified/flat.css";

export default function Finzly() {
  return (
    <>
      <div className="flat-certified-details-section">
        <div className="flat-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="flat-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="flat-certified-details-left">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="flat-certified-badge"
            />
            <div className="flat-certified-company-names">
              <a href="https://www.flatironssolutions.com/" target="_blank" rel="noopener noreferrer">
              <img
                src="/assets/flatirons/flat_logo.png"
                alt="Walkzero Logo"
                className="flat-certified-company-logo"
              />
            </a>
              <h1 className="flat-certified-full-name">
               Flatirons Solutions India Pvt Ltd
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="flat-certified-details-right">
            <img
              src="/assets/flatirons/flat_1.jpg"
              alt="Finzly Office"
              className="flat-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="flat-certified-description">
          <h2>
            Why  Flatirons Solutions India Pvt Ltd is an Outstanding Workplaces
          </h2>
          <p>
           Flatirons Solutions is a leading provider of technical content and maintenance management solutions for the aerospace, defense, and aviation industries. With over 30 years of expertise, Flatirons helps organizations create, manage, and deliver mission-critical technical information, improving operational efficiency, regulatory compliance, and safety. Serving customers worldwide, the company empowers airlines, MROs, and OEMs with innovative digital solutions that streamline maintenance operations and enhance workforce productivity. Flatirons is committed to quality, information security, and privacy, maintaining certifications such as ISO 9001, ISO 27001, and ISO 27701. Flatirons is features as India’s Top 25 safest workplace by Kelp for 4 consecutive years.

          </p>
        </div>
        {/* Info Cards Section */}
        <div className="flat-certified-info-cards">
          <div className="flat-certified-info-card">
            <div className="flat-certified-info-title">COMPANY SIZE</div>
            <div className="flat-certified-info-value">250+ Employees</div>
          </div>
          <div className="flat-certified-info-card">
            <div className="flat-certified-info-title">INDUSTRY</div>
            <div className="flat-certified-info-value">IT - Aviation 

</div>
          </div>
          <div className="flat-certified-info-card">
            <div className="flat-certified-info-title">CONNECT</div>
            <div className="flat-certified-info-icons">
              <span className="flat-certified-icon-round">
                <a href="https://www.flatironssolutions.com/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="flat-certified-icon-round">
                <a href="https://www.linkedin.com/company/flatironssolutions/?originalSubdomain=in" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="flat-certified-icon-round">
                <a href="https://www.facebook.com/hakunamatatasolutions/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
            </div>
          </div>
          <div className="flat-certified-info-card">
            <div className="flat-certified-info-title">LOCATION (HQ)</div>
            <div className="flat-certified-info-value">Chennai</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="flat-certified-recognition-section">
          <h2 className="flat-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="flat-certified-recognition-badge">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="flat-certified-recognition-image"
            />
          </div>
          <div className="flat-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at Finzly Section */}
        <div className="flat-certified-life-section">
          <h2 className="flat-certified-life-title">
            Life at  Flatirons Solutions India Pvt Ltd
          </h2>
          <div className="flat-certified-life-gallery">
            <div className="flat-certified-life-col">
              <img src="/assets/flatirons/flat_2.jpg" alt="Office 1" className="flat-certified-life-img" />
              <img src="/assets/flatirons/flat_3.jpg" alt="Team 1" className="flat-certified-life-img" />
            </div>
            <div className="flat-certified-life-col novin-certified-life-center">
              <img src="/assets/flatirons/flat_4.jpg" alt="Main Office" className="flat-certified-life-img flat-certified-life-img-large" />
            </div>
            <div className="flat-certified-life-col">
              <img src="/assets/flatirons/flat_5.jpg" alt="Office 2" className="flat-certified-life-img" />
              <img src="/assets/flatirons/flat_6.jpg" alt="Team 2" className="flat-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
